function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hamburger_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "hamburger_svg__Group_48",
  "data-name": "Group 48",
  transform: "translate(-1126 -82)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "hamburger_svg__Rectangle_1541",
  "data-name": "Rectangle 1541",
  className: "hamburger_svg__cls-1",
  width: 33,
  height: 4,
  rx: 2,
  transform: "translate(1126 82)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "hamburger_svg__Rectangle_1542",
  "data-name": "Rectangle 1542",
  className: "hamburger_svg__cls-1",
  width: 33,
  height: 4,
  rx: 2,
  transform: "translate(1126 93)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "hamburger_svg__Rectangle_1543",
  "data-name": "Rectangle 1543",
  className: "hamburger_svg__cls-1",
  width: 33,
  height: 4,
  rx: 2,
  transform: "translate(1126 104)"
}));

function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 26"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMyAyNiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2ZmZjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPGcgaWQ9Ikdyb3VwXzQ4IiBkYXRhLW5hbWU9Ikdyb3VwIDQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEyNiAtODIpIj4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfMTU0MSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTU0MSIgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzMiIGhlaWdodD0iNCIgcng9IjIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMjYgODIpIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE1NDIiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDE1NDIiIGNsYXNzPSJjbHMtMSIgd2lkdGg9IjMzIiBoZWlnaHQ9IjQiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTI2IDkzKSIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xNTQzIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNTQzIiBjbGFzcz0iY2xzLTEiIHdpZHRoPSIzMyIgaGVpZ2h0PSI0IiByeD0iMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTEyNiAxMDQpIi8+CiAgPC9nPgo8L3N2Zz4K";
export { SvgHamburger as ReactComponent };